import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb45c07"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-ellipsis font-gordita-regular text-[12px]"
}
const _hoisted_2 = { class: "item-ellipsis font-gordita-regular text-Text/text_high" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No matches found ")

import { IncrediButton, IncrediMenu, IncrediList, IncrediItem, IncrediField } from 'incredi-ui';

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageGroupsSelectMenu',
  props: {
    searchable: { type: Boolean },
    label: null,
    options: null,
    modelValue: null,
    maxHeight: null,
    disabled: { type: Boolean },
    minWidth: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:model-value', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  searchable?: boolean;
  label?: string;
  options: string[]; // Prop passed from the parent
  modelValue: string | null | undefined;
  maxHeight?: number;
  disabled?: boolean;
  minWidth?: number;
}

const searchInputModel = ref('');
const isSearchFocused = ref(false);
const menuOpen = ref(false);

// Props




// Local state derived from the prop
const localOptions = ref<string[]>([]); // Local ref to store paginated options
const loadedItems = ref(0); // Number of loaded items
const batchSize = 20; // Number of items to load per batch

// Watch for changes in `options` prop
watch(
  () => props.options,
  newOptions => {
    localOptions.value = newOptions.slice(0, loadedItems.value); // Keep local options in sync
  },
  { immediate: true },
);

// Infinite scroll loading logic
const onLoadItems = (index: number, done: () => void) => {
  if (loadedItems.value < props.options.length) {
    const nextBatch = props.options.slice(loadedItems.value, loadedItems.value + batchSize);
    localOptions.value.push(...nextBatch); // Append to local options
    loadedItems.value += nextBatch.length;
  }
  done(); // Signal that loading is complete
};

// Filtered options for search
const filteredOptions = computed(() => localOptions.value.filter(option => option.toLowerCase().includes(searchInputModel.value.toLowerCase())));

// Handle menu toggle
const handleMenuButtonClick = (e: MouseEvent) => {
  if (menuOpen.value) {
    e.stopPropagation();
    menuOpen.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_infinite_scroll = _resolveComponent("q-infinite-scroll")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediMenu), {
        direction: "bottom-sticky-left",
        class: _normalizeClass(["incredi-select", {
        'pointer-events-none': __props.disabled,
      }]),
        "offset-y": 4,
        "offset-x": 0,
        "model-value": __props.disabled ? false : menuOpen.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = (e) => (menuOpen.value = e))
      }, {
        content: _withCtx(() => [
          _createVNode(IbxScopedCss, {
            ref: "menuRef",
            style: {"width":"200px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_infinite_scroll, { onLoad: onLoadItems }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IncrediList), {
                    class: "selection-menu--incredi-list",
                    style: _normalizeStyle({ maxHeight: `${__props.maxHeight}px` })
                  }, {
                    default: _withCtx(() => [
                      (__props.searchable)
                        ? (_openBlock(), _createBlock(_unref(IncrediField), {
                            key: 0,
                            ref: "searchInput",
                            modelValue: searchInputModel.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInputModel).value = $event)),
                            class: "incredi-search--container mb-[8px]",
                            name: "search-input",
                            label: "Search",
                            size: "tiny",
                            clearable: "",
                            onFocusWithin: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocused.value = true)),
                            onFocusout: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = false))
                          }, {
                            prepend: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("i", {
                                  class: _normalizeClass([isSearchFocused.value ? 'text-Text/text_primary' : 'text-System/app_grey_76', "uil uil-search text-[24px] mr-2"])
                                }, null, 2)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), (option, index) => {
                        return (_openBlock(), _createBlock(_unref(IncrediItem), {
                          key: index,
                          class: "cursor-pointer overflow-hidden",
                          selected: option === __props.modelValue,
                          onClick: (e) => { emit('update:model-value', option); menuOpen.value = false; }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option), 1)
                          ]),
                          _: 2
                        }, 1032, ["selected", "onClick"]))
                      }), 128)),
                      (!_unref(filteredOptions).length)
                        ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                            key: 1,
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({ minWidth: __props.minWidth ? `${__props.minWidth}px` : undefined })
          }, [
            _createVNode(_unref(IncrediButton), {
              design: "ghost-neon",
              size: "tiny",
              disabled: __props.disabled,
              selected: (menuOpen.value || __props.modelValue) as any,
              "override-style": {
            height: '36px',
            background: __props.disabled ? '#F0F3F4' : '#FFFFFF',
          },
              onClick: handleMenuButtonClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({ width: __props.minWidth ? `${__props.minWidth - 18}px` : undefined }),
                  class: "flex gap-[4px] flex-nowrap items-center space justify-between whitespace-nowrap"
                }, [
                  (__props.label && !__props.modelValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(__props.modelValue), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["uil uil-angle-down text-Text/text_medium", {
                  '!text-text/text_disabled': __props.disabled,
                }]),
                      style: {"font-size":"20px","margin":"0 4px 0px 2px"}
                    }, null, 2)
                  ])
                ], 4)
              ]),
              _: 1
            }, 8, ["disabled", "selected", "override-style"])
          ], 4)
        ]),
        _: 1
      }, 8, ["model-value", "class"])
    ]),
    _: 1
  }))
}
}

})